// extracted by mini-css-extract-plugin
export var container = "_8a-0";
export var icon = "_8a-1";
export var text = "_8a-2";